import { render, staticRenderFns } from "./rumorManage.vue?vue&type=template&id=5d0e3cde&scoped=true"
import script from "./rumorManage.vue?vue&type=script&lang=js"
export * from "./rumorManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e3cde",
  null
  
)

export default component.exports